import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/global.scss";
import "./assets/responsive.scss";

import { Route, Routes } from "react-router-dom";

import About from "./pages/About";
import AuthContext from "./context/auth_context";
import Cart from "./pages/Cart";
import CatalogCoffee from "./pages/CatalogCoffee";
import CatalogEquipment from "./pages/CatalogEquipment";
import Checkout from "./pages/Checkout";
import Contact from "./pages/Contact";
import DeliveryPage from "./pages/DeliveryPage";
import ErrorPage from "./pages/ErrorPage";
import ErrorPaymentPage from "./pages/ErrorPaymentPage";
import Home from "./pages/Home";
import Intro from "./pages/Intro";
import PaymentMethods from "./pages/PaymentMethods";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProductDetail from "./pages/ProductDetail";
import Search from "./pages/Search";
import SecuredRoute from "./utils/security/SecuredRoute";
import SuccessPage from "./pages/SuccessPage";
import { ToastContainer } from "react-toastify";
import { globalActions } from "./reducers/globalActions";
import { securityActions } from "./reducers/security";
import store from "./reducers";
import { useSelector } from "react-redux";
import CatalogMerch from "./pages/CatalogMerch";

//css

//pages

const phpToken = localStorage.getItem("phpToken");
const loggedUser = JSON.parse(localStorage.getItem("loggedUser"));

if (phpToken) {
  let items = {
    validToken: phpToken,
    loggedUser,
  };
  store.dispatch(securityActions.setCurrentUser(items));
}

const cartData = localStorage.getItem("cart");

if (cartData && cartData !== "undefined") {
  const infoCart = JSON.parse(cartData);
  store.dispatch(globalActions.dataCartInfo(infoCart));
} else {
  // Opcionalno, obavestite korisnika da je korpa prazna
  localStorage.removeItem("cart");
}

function App() {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);

  return (
    <AuthContext.Provider
      value={{
        ...loggedUserReducer,
      }}
    >
      <Routes>
        {/* <Route exact path="/" element={<Intro />} /> */}
        <Route
          exact
          path="/"
          element={
            <SecuredRoute>
              <Home />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/equipment"
          element={
            <SecuredRoute>
              <CatalogEquipment />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/coffee"
          element={
            <SecuredRoute>
              <CatalogCoffee />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/merch"
          element={
            <SecuredRoute>
              <CatalogMerch />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/product/:id"
          element={
            <SecuredRoute>
              <ProductDetail />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/contact"
          element={
            <SecuredRoute>
              <Contact />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/about"
          element={
            <SecuredRoute>
              <About />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/checkout"
          element={
            <SecuredRoute>
              <Checkout />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/privacy-policy"
          element={
            <SecuredRoute>
              <PrivacyPolicy />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/cart"
          element={
            <SecuredRoute>
              <Cart />
            </SecuredRoute>
          }
        />
        <Route
          exact
          path="/search"
          element={
            <SecuredRoute>
              <Search />
            </SecuredRoute>
          }
        />

        <Route
          path="/success-page"
          element={
            <SecuredRoute>
              <SuccessPage />
            </SecuredRoute>
          }
        />

        <Route
          path="/error-payment-page"
          element={
            <SecuredRoute>
              <ErrorPaymentPage />
            </SecuredRoute>
          }
        />

        <Route
          path="/delivery"
          element={
            <SecuredRoute>
              <DeliveryPage />
            </SecuredRoute>
          }
        />

        <Route
          path="/payment-methods"
          element={
            <SecuredRoute>
              <PaymentMethods />
            </SecuredRoute>
          }
        />

        <Route
          path="*"
          element={
            <SecuredRoute>
              <ErrorPage />
            </SecuredRoute>
          }
        />
      </Routes>
      <ToastContainer />
    </AuthContext.Provider>
  );
}

export default App;
